var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnAceptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 86,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ACF593",
    d: "M31.404 1.5h21.192c7.444 0 12.876.003 17.029.562 4.11.552 6.74 1.624 8.715 3.598 1.974 1.975 3.046 4.605 3.599 8.715.558 4.153.561 9.585.561 17.03v17.19c0 7.445-.003 12.877-.561 17.03-.553 4.11-1.625 6.74-3.6 8.715-1.974 1.974-4.604 3.046-8.714 3.599-4.153.558-9.585.561-17.03.561h-21.19c-7.445 0-12.877-.003-17.03-.561-4.11-.553-6.74-1.625-8.715-3.6-1.974-1.974-3.046-4.604-3.598-8.714-.559-4.153-.562-9.585-.562-17.03v-17.19c0-7.445.003-12.877.562-17.03.552-4.11 1.624-6.74 3.598-8.715 1.975-1.974 4.605-3.046 8.715-3.598 4.153-.559 9.585-.562 17.03-.562"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A54F",
    strokeWidth: 3,
    d: "M31.404 1.5h21.192c7.444 0 12.876.003 17.029.562 4.11.552 6.74 1.624 8.715 3.598 1.974 1.975 3.046 4.605 3.599 8.715.558 4.153.561 9.585.561 17.03v17.19c0 7.445-.003 12.877-.561 17.03-.553 4.11-1.625 6.74-3.6 8.715-1.974 1.974-4.604 3.046-8.714 3.599-4.153.558-9.585.561-17.03.561h-21.19c-7.445 0-12.877-.003-17.03-.561-4.11-.553-6.74-1.625-8.715-3.6-1.974-1.974-3.046-4.604-3.598-8.714-.559-4.153-.562-9.585-.562-17.03v-17.19c0-7.445.003-12.877.562-17.03.552-4.11 1.624-6.74 3.598-8.715 1.975-1.974 4.605-3.046 8.715-3.598 4.153-.559 9.585-.562 17.03-.562Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#127C29",
    fillRule: "evenodd",
    d: "M62.653 24.256a4.91 4.91 0 0 1 0 6.942L38.108 55.744a4.91 4.91 0 0 1-6.943 0l-9.818-9.818a4.91 4.91 0 0 1 6.942-6.943l6.347 6.347 21.075-21.074a4.91 4.91 0 0 1 6.942 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 84,
    height: 86,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.647059 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_584_15211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_584_15211",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAceptIcon);
export default __webpack_public_path__ + "static/media/btn-acept-Icon.e0c80de8589f921fe895d96d7521c9b6.svg";
export { ForwardRef as ReactComponent };